import Modal from './Modal'

export default function ConfirmModal({
  open,
  title = 'Подтверждение',
  message,
  confirmLabel = 'Да',
  cancelLabel = 'Отмена',
  onConfirm,
  onCancel,
  danger = false,
  confirmDisabled = false,
}) {
  return (
    <Modal
      open={open}
      title={title}
      titleId="confirm-modal-title"
      onClose={onCancel}
      footer={
        <div className="modal-actions">
          <button
            type="button"
            className="modal-btn modal-btn-secondary"
            onClick={onCancel}
            disabled={confirmDisabled}
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            className={`modal-btn ${danger ? 'modal-btn-danger' : 'modal-btn-primary'}`}
            onClick={onConfirm}
            disabled={confirmDisabled}
          >
            {confirmLabel}
          </button>
        </div>
      }
    >
      {message && <p className="modal-message">{message}</p>}
    </Modal>
  )
}
